import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import { startLoadingSpinner, stopLoadingSpinner } from "../../csf-ufc-pivotal/includes/utils";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {
  buildSearchConditionsContains,
  getSortingQuery,
  findRemovedItems,
  clearSearchBtn,
  updateHeadingBasedOnUrl,
  removeErrFromValidItems, resetErrMessages
} from "../includes/utils";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import {
  CsfPivotalFournisseurAddFormateur
} from "../csf-fournisseur-gestion-list-detail/csf-fournisseur-detail-list-add-formateur";
import {
  CsfPivotalFournisseurAddFormateurList
} from "../csf-fournisseur-gestion-list-detail/csf-fournisseur-detail-list-add-formateur-list";
import { CsfPivotalFournisseurGestionFormateursStep5Table } from "./csf-fournisseur-recognition-request-step-5-table";
import {
  CsfPivotalFournisseurFormateurModal
} from "../csf-fournisseur-gestion-formateurs/csf-fournisseur-gestion-formateurs-modal";
import { CsfPivotalFournisseurDeleteModal } from "../includes/csf-fournisseur-delete-modal";
import CsfFournisseurRecognitionRenewalTitle
  from "../includes/csf-fournisseur-recognition-renewal-title";
import JustValidate from "just-validate";

export function FournisseurRecognitionRequestStepFiveBlock({
  hasPreviousRenewalEndDate,
  accessToken,
  apiUrl,
  apiEnv,
  form,
  currentStep,
  onStepChange,
  updateForm
}) {
  const [editTrainer, setEditTrainer] = useState('');

  const [validator, setValidator] = useState(null);
  const [startRow, setStartRow] = useState(1);
  const [startRowList, setStartRowList] = useState(1);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [inputSearchValueList, setInputSearchValueList] = useState('');
  const [total, setTotal] = useState(0);
  const [totalList, setTotalList] = useState(0);
  const [isSearchList, setIsSearchList] = useState(true);
  const [isSearch, setIsSearch] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [deleteType, setDeleteType] = useState('');
  const [isELearning, setIsElearning] = useState(false);
  const [isTrainersUndetermined, setIsTrainersUndetermined] = useState(null);
  const offset = 5;

  // all trainers
  const [trainers, setTrainers] = useState([]);

  // all lists of trainers
  const [trainersList, setTrainersList] = useState([]);

  // untouched activeTrainer
  const [defaultActiveTrainer, setDefaultActiveTrainer] = useState([]);

  // trainers associated with a training - no search - no pagination
  const [activeTrainer, setActiveTrainer] = useState([]);

  // used to reset slicedFilteredTrainers with search filter
  const [filteredTrainers, setFilteredTrainers] = useState([]);

  // trainers shown in the table (with filter and pagination)
  const [slicedFilteredTrainers, setSlicedFilteredTrainers] = useState([]);


  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = (urlParams.get('renewal') === 'true' || hasPreviousRenewalEndDate);

  /*
  * On component mounts fetch data of the trainers already associated with a training
  * */
  useEffect(() => {
    if (Object.keys(form).length !== 0) {// wait for the form data to be fetch before updating the activeTrainers
      const keysToExtract = ["First_Name", "Last_Name", "Contact_Id", "Contact_Status__Rn_Descriptor", "Contact_Email__Rn_Descriptor", "REDU_Activity__Trainer_Id", "IPF_Matricule_Bridge"];

      const mappedArray = form.Formateur__Secondary.map(obj => {
        const newObj = {};
        keysToExtract.forEach(key => {
          if (key === "Contact_Status__Rn_Descriptor") {
            newObj["Contact_Status"] = obj[key];
          } else if (key === "Contact_Email__Rn_Descriptor") {
            newObj["Contact_Email"] = obj[key];
          } else {
            newObj[key] = obj[key];
          }
        });
        return newObj;
      });
      setDefaultActiveTrainer(mappedArray);
      setActiveTrainer(mappedArray);

      if (form.REDU_Activity_Type_Id === "AAAAAAAAAAE=" || form.REDU_Activity_Type_Id__Rn_Descriptor === "Formation en ligne (E-learning, asynchrone)") {
        setIsElearning(true);
        if (form.Formateur__Secondary.length === 0) {
          setIsTrainersUndetermined(true);
        } else {
          setIsTrainersUndetermined(form.EP_AucunFormateur);
        }
      } else {
        setIsElearning(false);
        setIsTrainersUndetermined(form.EP_AucunFormateur);
      }

    }
  }, [form]);

  /*
  * When the accessToken is fetched and state is updates
  * */
  useEffect(() => {
    if (accessToken) {
      getTrainers();
    }
  }, [accessToken]);

  useEffect(() => {
    const validator = new JustValidate('#form-step05');

    if (slicedFilteredTrainers.length === 0) {
      validator.addField('#chkConfirmNoTrainer', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required')
        },
      ]);
    } else if (validator.fields.length > 0) {
      validator.removeField('#chkConfirmNoTrainer');
    }

    setValidator(validator);
  }, [slicedFilteredTrainers]);

  /*
  * When the data of the active trainers is pulled, filter its to make the pagination works
  * */
  useEffect(() => {
    setFilteredTrainers(activeTrainer);
    setSlicedFilteredTrainers(activeTrainer.slice((startRow - 1), (startRow + offset) - 1));
    setTotal(activeTrainer.length);
  }, [activeTrainer, startRow]);

  /*
  * When pagination or search is used, remount the trainers array
  * */
  useEffect(() => {
    setSlicedFilteredTrainers(filteredTrainers.slice((startRow - 1), (startRow + offset) - 1));
    setIsSearch(false);
  }, [isSearch]);

  /*
  * Get all the list available
  * */
  useEffect(() => {
    if (accessToken) {
      getTrainersList();
      setIsSearchList(false);
    }
  }, [accessToken, startRowList, isSearchList]);

  function handleNextStepClick() {
    onStepChange(currentStep + 1); // Call the callback function with new count
  }

  function handlePreviousStepClick() {
    onStepChange(currentStep - 2); // Call the callback function with new count
  }

  function goToSpecificStep(step) {
    onStepChange(step); // Call the callback function with new count
  }

  /*
  * Triggered when the search input is used. Filter the active trainer array with the good results.
  * */
  const handleSearchBtn = (event) => {
    if (event.key === 'Enter' || event.type === "click") {
      event.preventDefault();
      let filtered = activeTrainer;
      if (inputSearchValue !== '') {
        filtered = activeTrainer.filter((trainer) =>
          trainer.First_Name.toLowerCase().includes(inputSearchValue.toLowerCase()) ||
          trainer.Last_Name.toLowerCase().includes(inputSearchValue.toLowerCase()) ||
          trainer.Contact_Email.toLowerCase().includes(inputSearchValue.toLowerCase())
        );
      }
      setFilteredTrainers(filtered);
      setTotal(filtered.length);
      setStartRow(1);
      setIsSearch(true);
    }
  };

  /*
  * Method that handle the value changed on the search bar.
  * */
  function handleSearchChange(event) {
    setInputSearchValue(event.target.value);
  }

  /*
  * Method that handle the value changed on checkbox.
  * */
  function handleChangeCheck(event) {
    setIsTrainersUndetermined(event.target.checked);
  }

  /*
  * Method that handle the change on the activetrainer array when trainers are added
  * */
  function updateActiveTrainersList(newValue) {
    setActiveTrainer([...activeTrainer, ...newValue]);
  };

  /*
  * Method that handle the fetch of all trainers available to be added to a training
  * */
  function getTrainers() {
    let requestData = {
      startRow: startRow,
      ParameterValues: ["AAAAAAAAADg="],
      matchCondition: 1,
      search: 'CSF_EP_UXContacts_REST',
      searchResultsList: 'CSF_EP_UXContact_SRL'
    };

    let searchConditions = buildSearchConditionsContains(inputSearchValue, ["First_Name", "Last_Name", "Status_Combo", "Email", "IPF_Matricule_Bridge"]);
    requestData.sort = getSortingQuery("Last_Name", 'asc');

    if (searchConditions.length > 0) {
      requestData.conditions = searchConditions;
    }
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setTrainers(response.payload.data.rows);
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to fetch the trainers lists.
  * */
  function getTrainersList() {
    const requestData = buildMainBodyDataResquestTrainerList();
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setTrainersList(response.payload.data.rows);
          setTotalList(response.payload.data.searchTotal);
        }
        stopLoadingSpinner();
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to build the body array for the request
  * */
  function buildMainBodyDataResquestTrainerList() {
    let requestData = {
      maxRows: offset,
      startRow: startRowList,
      ParameterValues: [""],
      matchCondition: 1,
      search: 'CSF_EP_UxContactLists_REST',
      searchResultsList: 'CSF_EP_ContactLists_SRL'
    };

    let searchConditions = buildSearchConditionsContains(inputSearchValueList, ["List_Name"]);

    if (searchConditions.length > 0) {
      requestData.conditions = searchConditions;
    }

    return requestData;
  }

  /*
  * Method to send the form step 5
  * */
  function submitFormStep5(e) {
    e.preventDefault();
    validator.revalidate();
    const removedItems = findRemovedItems(defaultActiveTrainer, activeTrainer, 'formateurs');
    if (removedItems.length > 0) {
      deleteFormateur(removedItems);
    }

    if (activeTrainer.length > 0 || isTrainersUndetermined) {

      let trainersToAdd = activeTrainer.map(obj => ({
        REDU_Activity__Trainer_Id: obj.REDU_Activity__Trainer_Id !== undefined ? obj.REDU_Activity__Trainer_Id : '',
        Contact_Id: obj.Contact_Id
      }));

      setTimeout(() => {
        validator.revalidate();
        resetErrMessages();
        if (validator?.isValid) {
          const requestData = {
            form: 'CSF_EP_UXRecognition_5_REST',
            recordId: form?.REDU_Activity_Id,
            deltaData: ({
              REDU_Activity_Trainer__Secondary: trainersToAdd,
              Formateur__Secondary: ([{
                REDU_Activity__Cycle_Id: form.Cycle__Secondary[0].REDU_Activity__Cycle_Id,
                EP_AucunFormateur: isTrainersUndetermined
              }])
            })
          };
          startLoadingSpinner();
          const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
          pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
            .then(response => {
              if (response?.success && response?.payload != null) {
                updateForm();
                stopLoadingSpinner();
                handleNextStepClick();
              }
            })
            .catch(error => {
              stopLoadingSpinner();
              console.error(error);
            });
        } else {
          document.getElementById("emptyList").classList.add("error-label");
          removeErrFromValidItems();
        }

      });
    }
  }

  /*
  * Method to delete the formateur from an activity
  * */
  function deleteFormateur(removedItems) {
    removedItems.forEach(item => {
      const requestData = {
        form: 'CSF_EP_UXContact_List_Delete',
        recordId: item?.REDU_Activity__Trainer_Id,
      };
      const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
      pivotalFormApi.callFormDeleteEndpoint(requestData, '_Espace_Partenaire')
        .then(response => {
        })
        .catch(error => {
          console.error(error);
        });
    });
  }

  /*
  * Method that handle the removing of a/all trainer(s) inside the activeTrainer array
  * */
  function handleDeleteTrainer() {
    if (deleteId !== "") {
      if (deleteId === "all") {
        setActiveTrainer([]);
      } else {
        const data = activeTrainer.filter(item => item.Contact_Id !== deleteId);
        setActiveTrainer(data);
      }

      setDeleteType('');
      setDeleteId('');
    }
  }

  /*
  * Methods that sets which trainer(s) to delete and which modal Delete message to show.
  * */
  function handleDeleteId(id) {
    setDeleteType('requestTrainer');
    setDeleteId(id);
  }

  function trashAllTrainers() {
    setDeleteType('requestTrainers');
    setDeleteId('all');
  }

  function handleCancelModal() {
    setDeleteType('');
    setDeleteId('');
  }

  /*
  * Method that click on the edit button to open the edit modal with the right info
  * */
  function handleModalClick(contactID) {
    setEditTrainer(contactID);
  }

  /*
  * Method that handle the search inside the add trainers modal
  * */
  function triggerTrainerListSearch(searchListTerm) {
    setInputSearchValueList(searchListTerm);
    setStartRowList(1);
    setIsSearchList(true);
  }

  /*
  * Method import trainers from the lists,
  * */
  function importTrainerList(trainers) {
    const newTrainersToAdd = trainers.filter(trainer =>
      !activeTrainer.some(existingTrainer => existingTrainer.Contact_Id === trainer.Contact_Id)
    );
    setActiveTrainer([...activeTrainer, ...newTrainersToAdd]);
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch() {
    setFilteredTrainers(activeTrainer);
    setTotal(activeTrainer.length);
    setStartRow(1);
    setIsSearch(true);
  }

  // Change page title H1 if renewal
  useEffect(() => {
    updateHeadingBasedOnUrl("step5", "renewal", window.Drupal.t('fournisseur.creation_form.page.title'), window.Drupal.t('fournisseur.creation_form.page.renew.title'), hasPreviousRenewalEndDate);
  }, [hasPreviousRenewalEndDate]);

  return (
    <main className="fournisseur recognition">
      <h1 id="step5">{window.Drupal.t('fournisseur.creation_form.page.title')}</h1>

      <CsfFournisseurRecognitionRenewalTitle
        isRenewal={isRenewal || hasPreviousRenewalEndDate}
        formData={form} />

      <div className="content">
        <aside className="form-steps-legend">
          <ol>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(1)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step1')}</span></button>
            </li>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(2)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step2')}</span></button>
            </li>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(3)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step3')}</span></button>
            </li>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(4)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step4')}</span></button>
            </li>
            <li className="active"><span>{window.Drupal.t('fournisseur.creation_form.steps.step5')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step6')}</span></li>
          </ol>
        </aside>

        <div className="form-steps-content">
          <form onSubmit={submitFormStep5} id="form-step05">
            <fieldset>
              <legend className="visually-hidden">{window.Drupal.t('fournisseur.creation_form.page.title')}</legend>

              <div className="form-container">

                <h2>{window.Drupal.t('fournisseur.gestion.formateurs.title')}</h2>

                {(isTrainersUndetermined === false || slicedFilteredTrainers.length !== 0) && (

                  <div className="row action-buttons action-buttons-top">
                    <div className="col text-center">
                      <button className="button btn-with-icon btn-larger" type="button" data-toggle="modal"
                        data-target="#addFormateurList">
                        <span className="icon-import"><span className="d-none">&nbsp;</span></span>
                        {window.Drupal.t('fournisseur.creation_form.btn.import.trainers')}
                      </button>
                    </div>
                    <div className="col text-center">
                      <button className="button btn-with-icon btn-outlined btn-larger" type="button" data-toggle="modal"
                        data-target="#AddFormateur">
                        <span className="icon-add-people"><span className="d-none">&nbsp;</span></span>
                        {window.Drupal.t('fournisseur.creation_form.btn.link.trainers')}
                      </button>
                    </div>
                  </div>

                )}

                <div className="form-outline">

                  <div className="search-container">
                    <label htmlFor="formTrainersSearch" className="sr-only">{window.Drupal.t('search.label')}</label>
                    <input type="search" id="formTrainersSearch" onChange={handleSearchChange}
                      onKeyDown={handleSearchBtn}
                      placeholder={window.Drupal.t('fournisseur.search.placeholder')} value={inputSearchValue} />
                    <button className="search-close-icon btn-link"
                      aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                      onClick={(e) => {
                        clearSearchBtn(e, setInputSearchValue);
                        retriggerEmptySearch();
                      }}
                    >
                      <i className="icon icon-remove"></i>
                    </button>
                    <button onClick={handleSearchBtn} className="button btn-outlined search-icon"
                      title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
                      <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
                    </button>
                  </div>

                  <CsfPivotalFournisseurGestionFormateursStep5Table
                    trainers={slicedFilteredTrainers}
                    handleModalClick={handleModalClick}
                    handleDeleteId={handleDeleteId}
                    trashAllTrainers={trashAllTrainers}
                    isTrainersUndetermined={isTrainersUndetermined}
                    handleChangeCheck={handleChangeCheck}
                    isIQPF={form.Submitted_To_Financial_Instit}
                    isELearning={isELearning}
                  />

                  <div className="pagination-wrapper space-between-wrapper smaller-wrapper">
                    <CsfFournisseurPagination
                      startRow={startRow}
                      offset={offset}
                      total={total}
                      setStartRowFunction={setStartRow}
                    />
                  </div>

                </div>
              </div>

              <div className="row action-buttons">
                <div className="col text-center">
                  <button className="button btn-outlined btn-larger" type="button" onClick={() => handlePreviousStepClick()}>
                    {window.Drupal.t('fournisseur.previous.btn')}
                  </button>
                </div>
                <div className="col text-center">
                  <button className="button btn-larger" type="submit">
                    {window.Drupal.t('fournisseur.next.btn')}
                  </button>
                </div>
              </div>

            </fieldset>
          </form>
        </div>
      </div>

      <CsfPivotalFournisseurAddFormateur
        type="form"
        trainers={trainers} // Envoyer tous les trainers
        currentTrainers={activeTrainer} //Envoyer les trainers de la liste courante
        updateActiveTrainersList={updateActiveTrainersList}
      />

      <CsfPivotalFournisseurAddFormateurList
        trainersList={trainersList} // Envoyer tous les trainers
        total={totalList}
        startRow={startRowList}
        offset={offset}
        setStartRowListFunction={setStartRowList}
        triggerTrainerListSearch={triggerTrainerListSearch}
        importTrainerList={importTrainerList}
        accessToken={accessToken}
        apiUrl={apiUrl}
        apiEnv={apiEnv}
      />

      <CsfPivotalFournisseurFormateurModal
        type="form"
        accessToken={accessToken}
        apiUrl={apiUrl}
        apiEnv={apiEnv}
        editTrainer={editTrainer}
        addToList={false}
      />

      <CsfPivotalFournisseurDeleteModal
        deleteType={deleteType}
        handleDeleteModal={handleDeleteTrainer}
        handleCancelModal={handleCancelModal}
      />

    </main>
  );
}

FournisseurRecognitionRequestStepFiveBlock.propTypes = {
  hasPreviousRenewalEndDate: PropTypes.bool,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func,
  updateForm: PropTypes.func
};
